import { useQuery } from "@tanstack/react-query";
import type { StoreOptionsResponse } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

export function useStoreOptionsQuery() {
  const query = useQuery({
    queryKey: queryKeys.admin.storeOptions(),
    queryFn: () =>
      apiJsonClient<StoreOptionsResponse>(endpoints.admin.storeOptions),
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
